
export const signInWithESIAThunkAction = () => async (dispatch) => {
    try {
        window.location.assign("https://po-test.alrosa.ru/api/v1/auth/signin/esia/po");
    } catch (e) {
        // console.log(e?.response)
    }
};
